import React from 'react';
import styles from './Block.module.scss';

interface BlockProps {
  children: React.ReactNode;
}

export const Block: React.FC<BlockProps> = ({ children }) => {
  return <div className={styles.block}>{children}</div>;
};
